








import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import { utilService } from '../util-service';
import chartUtil from './util.service';
import SwChartChartJsMixin from './sw-chart-chart-js.mixin.vue';
import { ChartOptions, AnnotationConfig } from './types';
import _ from 'lodash';
const streaming = require('chartjs-plugin-streaming');

Chart.plugins.unregister(streaming);
@Component
export default class SwChartLine extends mixins(SwChartChartJsMixin) {
  @Prop({ type: Array, default () { return []; } })
  chartData: Chart.ChartDataSets[];

  @Prop({ type: Number, default: -1 })
  value: number; // selected index.

  @Prop(Array)
  labels: string[];

  @Prop({ type: Array, default() { return utilService.colorConst.chartPrimaryPalette; } })
  colorPalette: string[];

  @Prop({ type: Boolean, default: false })
  simple: boolean;

  @Prop(Function)
  updateStream: Function;

  @Prop({ type: Object, default() { return {}; } })
  axisOpts: Chart.ChartScales;

  @Prop({ type: Boolean, default: false })
  enableBackground: boolean;

  @Prop(Object)
  annotationConfig: AnnotationConfig;

  @Prop({ type: Boolean, default: false })
  smoothLine: boolean;

  selected = [-1, -1];
  paused: boolean = false;
  private priAnnotationConfig: AnnotationConfig = { annotations: [] };

  get chartOptions(): ChartOptions {
    const basic: ChartOptions = {
      legend: {
        display: false,
        labels: {
          fontColor: chartUtil.chartTextColor(this.theme),
        },
      },
      onHover: (evt: any) => {
        // to be debounced..
        if (this.chartInstance) {
          const elements = (this.chartInstance.getElementAtEvent(evt) as any);
          if (elements && elements.length > 0) {
            this.selected[0] = elements[0]._datasetIndex;
            this.selected[1] = elements[0]._index;
            (this.$refs.chartCanvas as HTMLElement).style.cursor = 'pointer';
            this.drawDashLine(elements[0]._view.y);
          } else {
            this.selected = [-1, -1];
            (this.$refs.chartCanvas as HTMLElement).style.cursor = 'default';
          }
        }
      },
      tooltips: {
        intersect: true,
      },
      scales: _.merge(
        {
          yAxes: [{
            gridLines: {
              color: chartUtil.chartGridColor(this.theme),
            },
            scaleLabel: {
              display: true,
              labelString: this.labelString,
              fontColor: chartUtil.chartTextColor(this.theme),
            },
            ticks: {
              autoSkipPadding: 40,
              padding: 20,
              fontColor: chartUtil.chartTextColor(this.theme),
            },
          }],
          xAxes: [{
            gridLines: {
              color: chartUtil.chartGridColor(this.theme),
            },
            ticks: {
              autoSkip: false,
              fontColor: chartUtil.chartTextColor(this.theme),
            },
          }],
        },
        this.axisOpts,
      ),
      plugins: {},
      annotation: this.annotationConfig,
    };
    if (this.updateStream !== undefined) {
      const streaming = {
        onRefresh: this.updateStream,
        delay: 2000,
        refresh: 2000, // refresh interval.
        pause: this.paused,
      };
      basic!.plugins!.streaming = streaming;
      basic!.scales!.xAxes![0].type = 'realtime';
      (basic!.scales!.xAxes![0] as any).realtime = {};
    }
    if (this.simple) {
      const nullTicks = [
        {
          ticks: {
            callback () {
              return null;
            },
          },
          gridLines: {
            color: chartUtil.chartGridColor(this.theme),
          },
        },
      ];
      Object.assign(basic, {
        scales: {
          yAxes: nullTicks,
          xAxes: nullTicks,
        },
      });
    }
    return _.merge(basic, this.options);
  }

  get normalizedDatasets() {
    let defaultDataset = {};
    if (this.simple || this.updateStream) {
      defaultDataset = {
        pointRadius: 0,
        borderWidth: 2,
        pointHitRadius: 4,
        pointHoverRadius: 0,
      };
      // @ts-ignore;
      if (!this.smoothLine) defaultDataset.lineTension = 0;
    } else {
      defaultDataset = {
        pointStyle: 'circle',
        pointRadius: 4,
        pointHitRadius: 4,
        pointBorderWidth: 1,
        pointBackgroundColor: chartUtil.pointBackgroundColor(this.theme),
        // pointHoverBackgroundColor: utilService.colorConst.dark_iconSelected,
      };
    }
    return this.chartData.map((dataset: Chart.ChartDataSets, index: number) => {
      return _.merge({}, defaultDataset, dataset, {
        borderColor: this.colorPalette[index],
        backgroundColor: this.enableBackground ? chartUtil.hex2rgba(this.colorPalette[index], .8) : 'transparent',
      });
    });
  }

  get labelString(): string {
    if (this.chartData[0] && this.chartData[0].label) {
      return `${this.chartData[0].label}`;
    }
    return '';
  }

  public pauseStream(pause: boolean) {
    this.paused = pause;
  }

  drawDashLine(horizontal: number) {
    if (this.chartInstance && this.chartInstance.ctx) {
      const ctx = this.chartInstance.ctx;
      const chartArea = this.chartInstance.chartArea;
      ctx.save();
      ctx.setLineDash([10, 5]);
      ctx.lineWidth = 1;
      ctx.strokeStyle = chartUtil.chartAuxiliaryColor(this.theme);
      ctx.beginPath();
      ctx.moveTo(chartArea.left, horizontal);
      ctx.lineTo(chartArea.right, horizontal);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }
  }

  private updateData() {
    if (this.chartInstance && !this.updateStream) {
      chartUtil.updateChartRegularData(this.chartInstance, this.labels, this.normalizedDatasets);
    }
  }

  @Watch('labels')
  @Watch('theme')
  @Watch('normalizedDatasets')
  @Watch('chartOptions')
  private onConfigChanged() {
    if (this.chartInstance) {
      this.updateData();
      (this.chartInstance as any).options = this.chartOptions;
      this.chartInstance.update();
    }
  }

  created() {
    this.myCssPrefix = 'sw-chart-line';
  }

  mounted() {
    this.initChart({
      type: 'line',
      data: {
        labels: this.labels,
        datasets: this.normalizedDatasets,
      },
      options: this.chartOptions,
      plugins: [
        (() => {
          if (this.updateStream !== undefined) {
            return streaming;
          }
          return {};
        })(),
      ],
    });
  }
}
